import { render, staticRenderFns } from "./edit-video.vue?vue&type=template&id=68d359ea&"
import script from "./edit-video.vue?vue&type=script&lang=ts&"
export * from "./edit-video.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports